import { render, staticRenderFns } from "./CustomFieldItem.vue?vue&type=template&id=14392d6f&scoped=true"
import script from "./CustomFieldItem.vue?vue&type=script&lang=js"
export * from "./CustomFieldItem.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldItem.vue?vue&type=style&index=0&id=14392d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14392d6f",
  null
  
)

export default component.exports